module.exports = __webpack_public_path__ + "media/fr_ca_s2_Chloe.e11a7bff.mp3";